// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation_root__38oUU"};